export default {
  fr: "/",
  de: "/de-de",
  nl: "/nl-nl",
  en: "/en-en",
};
